export default {
  common_button_back: 'Zpět',
  common_button_cancel: 'Zrušit',
  common_button_next: 'Další',
  common_button_no: 'Ne',
  common_button_ok: 'Ok',
  common_button_reset: 'Reset',
  common_button_skip: 'Přeskočit',
  common_button_yes: 'Ano',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: 'Zadejte prosím vaši obchodní emailovou adresu',
  common_enterEmail_title: 'Váš email',
  common_error_message_cameraNotAllowed: 'Abyste mohli použít přístup k fotoaparátu, musíte ho povolit.',
  common_error_message_ForbiddenException: 'Nedostatečná práva',
  common_error_message_incorrectEmail: 'Zadejte správnou e-mailovou adresu',
  common_error_message_invalidCredentials: 'Ale ne! Uživatelské jméno nebo nesprávné heslo. Zkuste to prosím znovu',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_missingField: 'Povinné pole',
  common_error_message_noInternetConnection: 'Připojení k Internetu bylo ztraceno. Opakujte akci.',
  common_error_message_unauthorizedAccess: 'Neoprávněný přístup',
  common_error_message_webServiceWrongConnection: 'Během přenosu dat došlo k chybě. Zkuste to prosím znovu',
  common_error_title: 'Chyba',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_placeholder_optional: 'Nepovinné',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: 'Pro vytvoření nového stánku se připojte k webové aplikaci Proxyclick',
  common_setup_device_locked_content:
    'Tento stánek je již používán na jiném iPadu. Nastavením na tomto iPadu deaktivujete ten druhý. Jste si jisti, že chcete nastavit stánek na tomto iPadu?',
  common_setup_device_locked_continue_button: 'Nastavit tento kiosek',
  common_setup_device_locked_title: 'Stánek je již používán',
  common_setup_device_multiTenants: 'Skupina společností',
  common_setup_device_title: 'Vyberte svůj stánek',
  common_setup_loading_footer: 'Chcete-li přizpůsobit svůj stánek, připojte se k webové aplikaci Proxyclick',
  common_setup_loading_message: 'Konfigurace...',
  common_setup_loading_title: 'Váš stánek je nastaven...',
  common_setup_location_footer: 'Chcete-li vytvořit novu stránku, připojte se k webové aplikaci Proxyclick',
  common_setup_location_kiosk: 'kiosek',
  common_setup_location_kiosks: 'kiosky',
  common_setup_location_title: 'Zvolte svoji stránku',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: 'E-mail',
  common_setup_login_forgotPassword_button: 'Zapomněli jste heslo?',
  common_setup_login_password: 'Heslo',
  common_setup_login_title: 'Přihlaste se pomocí účtu Proxyclick',
  common_setup_ready_header: 'Jste připraveni nastavit tento iPad jako váš {0} kiosek?',
  common_setup_ready_message: 'Konfigurace zabere jen pár minut, pak bude váš kiosek připravit k použití',
  common_setup_ready_setup_button: 'Nastavit',
  common_setup_ready_title: 'Ahoj {0}',
  common_signup_company: 'Společnost',
  common_signup_email: 'E-mail',
  common_signup_error_name: 'Vložte prosím jméno a příjmení',
  common_signup_loading_message1:
    'Připojením k webové aplikaci Proxyclick můžete přizpůsobit váš stánek. Právě jsme Vám odeslali email s detailními informacemi.',
  common_signup_loading_message2: 'Na webové stránce můžete nastavit tiskárnu pro tisk odznaků při zapsání hostů.',
  common_signup_loading_message3: 'Také můžete povolit oznámí, které bude odesláno po zapsání hosta.',
  common_signup_loading_message4: 'A přizpůsobte váš stánek vašim barvám a vložte úvodní obrázek.',
  common_signup_loading_title: 'Nastavení účtu…',
  common_signup_name: 'Jméno',
  common_signup_name_placeholder: 'Jméno Příjmení',
  common_signup_password: 'Heslo',
  common_signup_title: 'Výtejte na Proxyclick',
  common_signup_tryFree_button: 'Odeslat',
  common_timeout_content: 'Přerušte dotykem',
  common_timeout_title: 'Návrat na domovskou obrazovku',
  common_tooltip_disable_button: 'Zakázat všechny tipy',
  common_tooltip_gotIt_button: 'Jasně',
  dm_delivery_confirmation_knownRecipient: 'Uživatel {{Host_Name}} byl informován, že jste doručili balíček',
  dm_delivery_confirmation_title: 'Děkujeme!',
  dm_delivery_confirmation_unknownRecipient:
    'Bylo vám zasláno oznámení, že jste {{Company_Name}} informovali o tom, že jste jim doručili balíček',
  dm_delivery_recipient_name: 'Pro koho je tento balíček určen?',
  dm_delivery_recipient_unknown_button: 'Nevím',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Byli jste zaregistrováni!',
  vm_checkin_confirmation_header_withPrint: 'Tiskne se odznak',
  vm_checkin_confirmation_message: 'Prosím posaďte se, {{Host_FirstName}} se vám bude hned věnovat',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Děkujeme!',
  vm_checkin_details_companyName: 'Společnost',
  vm_checkin_details_email: 'E-mail',
  vm_checkin_details_firstname: 'Jméno',
  vm_checkin_details_lastname: 'Příjmení',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn: 'Při dokončování vaší registrace došlo k chybě, kontaktujte prosím recepci',
  vm_checkin_flow_company: 'Společnost',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_flow_email: 'E-mail',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Ups, obrázek není v současné době dostupný (problém s internetovým připojením)',
  vm_checkin_flow_licensePlate: 'SPZ',
  vm_checkin_flow_mobile: 'Zadejte prosím své mobilní číslo',
  vm_checkin_flow_mobile_info: 'To bude použito pro kontakt s vámi v případě nouze, když jste v zařízení',
  vm_checkin_flow_tooltip_content:
    'Požádejte své návštěvníky o cokoli, co pomůže zlepšit jejich zkušenost, nebo udělejte registraci ještě bezpečnější. Můžete změnit pořadí otázek na základě odpovědí návštěvníka. Otázky, které vidíte, jsou přikladem pro demo verzi.',
  vm_checkin_flow_tooltip_title: 'Chytré otázky',
  vm_checkin_host_enterFullName: 'Zadejte celé jméno hostitele',
  vm_checkin_host_name: 'Koho jdete navštívit?',
  vm_checkin_host_notListed_block:
    'Jestliže neznáte hostitele nebo ho nemůžete najít na seznamu, oznamte to prosím na recepci',
  vm_checkin_host_notListed_continue: 'Není v seznamu',
  vm_checkin_host_tooltip_content:
    'Vyplňte zde své jméno a my vám pošleme email s oznámením, který obdrží vaši zaměstnanci při příchodu návštěvníka.',
  vm_checkin_host_tooltip_title: 'Oznámení o příchodu nového návštěvníka',
  vm_checkin_host_unknown_button: 'Nevím',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Souhlasím',
  vm_checkin_instructions_clearSignature_button: 'Vymazat',
  vm_checkin_instructions_sendCopy_button: 'Pošlete mi kopii prostřednictvím e-mailu',
  vm_checkin_instructions_sendCopyTo_button: 'Kopie bude odeslána na {0} (změna)',
  vm_checkin_instructions_sign: 'Podepište se zde prstem',
  vm_checkin_instructions_tooltip_content:
    'Hosté podpisem nebo jednoduchým poklepáním prokazují souhlas s vašimi pravidly pro návštěvy. Pravidla můžete přizpůsobit typu návštěníka, který se zapisuje. Tuto a mnohé další funkce můžete spravovat na nástěnce Proclick.',
  vm_checkin_instructions_tooltip_title: 'Podepsáno a zapečetěno',
  vm_checkin_method_name: 'Dobrý den, jak se jmenujete?',
  vm_checkin_method_name_enterFullName: 'Prosím, zadejte své celé jméno',
  vm_checkin_method_name_invitationQuestion: 'Obdrželi jste pozvánku s QR kódem?',
  vm_checkin_method_name_notRegistered_block: 'Není v seznamu? Obraťte se na recepci',
  vm_checkin_method_name_notRegistered_continue: 'Není v seznamu?',
  vm_checkin_method_tooltip_content:
    'Zaregistrujte se jako "Justin Diaz", abyste viděli, jak jsou rozpoznáni před-registrovaní a vracející se návštěvníci.\n\nNebo napiště jakékoli jméno, abyste viděli reakci na nečekané návštěvníky.',
  vm_checkin_method_tooltip_title: 'Rozpoznání návštěvníka',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Vyfotit',
  vm_checkin_picture_title: 'Vyfoťte se!',
  vm_checkin_picture_tooltip_content:
    'Kiosk můžete přizpůsobit vašim potřebám a snadno přidat nebo odebrat funkci, jako fotografování návštěvníků nebo tisk odznaků.',
  vm_checkin_picture_tooltip_title: 'Volitelné funkce',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Registrace',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Upravit detaily',
  vm_checkin_summary_groupStats: '{0} z {1} lidí už tam je',
  vm_checkin_summary_meetingTime: 'Setkání v {0}',
  vm_checkin_summary_reviewDetails_button: 'Prohlédnout podrobnosti o mé návštěvě',
  vm_checkin_summary_sendPass_button: 'Pošlete mi propustku pro budoucí návštěvy na můj smartphone',
  vm_checkin_summary_sendPassTo_button: 'Permanentní vstupenku bude zaslána {0} (změna)',
  vm_checkin_summary_takeNewPicture_button: 'Udělat novou fotku',
  vm_checkin_summary_title: 'Vaše návštěva na {{Company_Name}}',
  vm_checkin_summary_visiting: 'Návštěva {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Vítejte {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Vaše poslední návštěva proběhla naposledy dnes',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: 'Vítejte zpět {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Nashledanout {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Byli jste odhlášeni. Doufáme, že jste si užili naši návštěvu.',
  vm_checkout_confirmation_title: 'Děkujeme vám za vaši návštěvu!',
  vm_checkout_method_name: 'Please enter your name to check out',
  vm_checkout_method_name_notFound: 'Nebyl nalezen',
  vm_checkout_method_title: 'Odhlásit se',
  vm_identification_id_button: 'Naskenovat ID',
  vm_identification_qrCode_button: 'Naskenujte vaši pozvánku/pas',
  vm_infopack_confirmation: 'Děkujeme! Poslali jsme informace na {0}.',
  vm_infopack_email: 'Zadejte svůj e-mail, abychom vám mohli zaslat informace o Proxyclick',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: 'Pošlete mi info',
  vm_multiTenant_title: 'Vítejte, jakou společnosti jdete navštívit?',
  vm_product_footer_learnMore: 'Learn more',
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_qrCode_help: 'Podržte kód 10-15cm před kamerou',
  vm_qrCode_not_recognized: 'Kód nebyl rozpoznán',
  vm_qrCode_title: 'Naskenujte odznak nebo Passbook kód',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>INSTRUKCE PRO NÁVŠTĚVNÍKY A DŮVĚRNÁ DOHODA</h1> <p> Vítejte, jsme rádi, že tu jste jako host {{Company_Name}} v našem zařízení. </p> <h2> Instrukce pro ochranu zdraví a pro bezpečnost</h2><p>Během vaší návštěvy je vaše zdraví naší starostí. Proto požadujeme, abyste dodržovali následující: </p><ul><li><b> Přístup do prostro </b> je povolen jen v doprovodu zaměstnance {{Company_Name}} </li><li> Návštěvník <b>odznak</b> musí být nošen po celou dobu a při odchodu by měl být vrácen na recepci</li><li>V případě stavu nouze</b>musí všichni návstěvníci neprodleně opustit zařízení nejbližším bezpečným východem a nahlásit se na určeném místě shromáždění</li><li>Návtěvníci nesmí <b> pořizovat fotografie</b>(fotografie a videa) žádných prostor nebo okolním pozemků</li><li><b>Kouření je přísně zakázáno</b>uvnitř budov</li></ul><h2>Dohoda o mlčenlivosti</h2><p>Během návštěvy zařízení společnosti {{Company_Name}} se můžete dozvědět důvěrné informace (zahrnující, ale neomezující se na, informace týkající se technologií, procesů, vybavení, nákresů a specifikaci), které nejsou známy veřejnosi (dále jen &#34;Důvěrné informace&#34;).</p><p>Se zřetelem na vaše povolení návtěvy zařízení {{Company_Name}} a pro zdvořilosti rozšířené během vaší návštěvy souhlasíte, že nebudete, ani</p><p>(a)Sdělovat nebo jinak zpřístupňovat dalším žádné Důvěrné informace zveřejněné v prolvěhu této nebo jakékoli následující návštěvy; nebo</p><p>(b) Používat nebo pomáhat dalěím použít nebo dále vyvýjet jakkoli Důvěrné informace.</p><p>(c) Používat fotoaparát nebo video technologie pro zvěřejnění Důvěrných informací. </p><p>Registrací do zařízení potvrzujete a rozumíte unstrukcím o zdraví a bezpečnosti a Dohodě o mlčenlivosti.</p>',
  vm_signup_defaultInstruction_name: 'Instrukce k podepsání všemi návštěvníky',
  vm_signup_defaultInstruction_title: 'Přečtěte a podepište se níže',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Registrace',
  vm_welcome_checkout_button: 'Odhlášení',
  vm_welcome_delivery_button: 'Doručení',
  vm_welcome_hello_line1: 'Dobrý den,',
  vm_welcome_hello_line2: 'v {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Předregistrované návštěvy: při příchodu nebo odchodu přiložte svůj QR kód ke kameře',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_title: 'Vítejte v {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Pro přizpůsobení kiosku se přihlašte do webové aplikaci Proxyclick. Poslali jsme vám email s instrunkcemi. We webové aplikaci můžete nahrát vaše logo, obrázek pozadí a vybrat barvu, takže kiosek bude reprezentovat vaši značku.',
  vm_welcome_tooltip_title: 'Udělejte vlastní',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Naskenujte tento QR kód pomocí aplikace Proovr (zaměstnanci) nebo svého telefonu (návštěvy) a přihlaste se',
  vm_welcome_touchless_unexpected_qrCode_show: 'Naskenujte tento QR kód pomocí telefonu a přihlaste se jako návštěva',
  common_or: 'nebo',
};
